<template>
  <div>
    <div class="form-fields">
      <form-field-input
          label="Company Name"
          v-model="form.company_name"
          :validation-errors="validationErrors.company_name"
      ></form-field-input>

      <form-field-input
          label="Street Address"
          v-model="form.street_address"
          :validation-errors="validationErrors.street_address"
      ></form-field-input>

      <form-field-input
          label="City"
          v-model="form.city"
          :validation-errors="validationErrors.city"
      ></form-field-input>

      <form-field-select
          label="State"
          v-model="form.state"
          :validation-errors="validationErrors.state"
      >
        <option></option>
        <option
            v-for="state in usStates"
            :key="state.abbreviation"
            :value="state.abbreviation"
        >{{ state.abbreviation }}</option>
      </form-field-select>

      <form-field-input
          label="Postcode"
          v-model="form.postcode"
          :validation-errors="validationErrors.postcode"
      ></form-field-input>

      <form-field-timezones
          :entity="form"
          :validation-errors="validationErrors"
      ></form-field-timezones>
    </div>

    <close-account-modal
        ref="deleteAccountModal"
    ></close-account-modal>
  </div>
</template>

<script>
import {usStates} from '../services/staticData';
import {FormMixin} from "./forms.mixin";
import CloseAccountModal from "../modules/account/components/CloseAccountModal";

export default {
  name: "AccountForm",
  components: {
    CloseAccountModal
  },
  mixins: [FormMixin],
  props: ['formData'],
  data() {
    return {
      usStates,
      validationErrors: {},
      form: {}
    }
  },
  created() {
    this.form = this.$utils.clone(this.formData);
  },
  methods: {
    update() {
      return this.$api.accounts.update(this.form)
      .then((res) => {
        this.$buefy.toast.open({
          message: 'Your account information has been updated',
          type: 'is-success'
        });

        return res;
      });
    },
    delete() {
      return new Promise((resolve, reject) => {
        this.$refs.deleteAccountModal.open();
        reject('Opening customer feedback modal');
      });
    }
  },
}
</script>

<style scoped>

</style>
